var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"screening-trend"},_vm._l((_vm.screeningOutcomeTrend),function(reference,i){return _c('div',{key:(reference + "-" + i),staticClass:"reference-dot",class:reference.screeningOutcomeClass})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }